// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"843ae55d","389":"25f4fc10","453":"9e2675c7","455":"89210db8","977":"16c52d14"}[chunkId] + ".chunk.js";
};